import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import ImageLoader from './ImageLoader';

function CategoryViewGame({ game, userId, requestSlotUrl }) {

    return (
      <Card className="games__element__card" onClick={() => requestSlotUrl(game)}>
        <Card.Img
            as={ImageLoader}
            className="games__element__image"
            spinnerClassName="games__element__image games__element__image__spinner"
            variant="top"
            src={game.thumbnail}
            alt={game.name}
        />
        <Card.ImgOverlay className="games__element__overlay">
            <div className="games__element__overlay__background">
                { userId &&
                <div className="games__element__overlay__button"></div> }
            </div>
        </Card.ImgOverlay>
        <Card.Body className="games__element__body">
            <Card.Title className="games__element__title">{game.name}</Card.Title>
        </Card.Body>
      </Card>
    );
}


  export default CategoryViewGame;
